export interface IncomeFormRentKey {
    key: string;
    title: string;
    type: 'amount' | 'text';
    order: number;
    /** Group special rental income rows into their own table. */
    group?: 'specialRentalIncome';
}

export const INCOME_FORM_HOUSE_PROPERTY_RENT_KEYS: IncomeFormRentKey[] = [
    { key: 'propertyType', title: 'Property Type', type: 'text', order: 1 },
    { key: 'housePropertyAddress', title: 'Address of the Property', type: 'text', order: 2 },
    { key: 'anyCC', title: 'Is it in any city corporation', type: 'text', order: 2.1 },
    { key: 'selfOccupiedArea', title: 'Area Occupied for Personal Use/Dwelling', type: 'text', order: 2.2 },
    { key: 'occupiedAreaResidential', title: 'Area Rented Out', type: 'amount', order: 2.3 },
    { key: 'occupiedAreaCommercial', title: 'Area Rented Out', type: 'amount', order: 2.4 },
    { key: 'totalArea', title: 'Total Area of the Property', type: 'text', order: 2.5 },
    { key: 'rentalPeriodResidentialOrOther', title: 'Rental Period (Months)', type: 'amount', order: 2.6 },
    { key: 'rentalPeriodCommercial', title: 'Rental Period (Months)', type: 'amount', order: 2.7 },
    { key: 'serviceChargePaid', title: 'Service Charge paid by tenant', type: 'text', order: 2.8 },
    { key: 'ownershipRadio', title: 'Are you the only owner', type: 'text', order: 2.9 },
    { key: 'shareOfOwnership', title: 'Share of Your Ownership (%)', type: 'text', order: 3 },
    { key: 'otherOwnersName', title: 'Name, TIN/NID of Other Owner(s)', type: 'text', order: 4 },
    { key: 'annualResidentialOrOther', title: 'Annual Rent', type: 'amount', order: 5 },
    { key: 'annualCommercial', title: 'Annual Rent', type: 'amount', order: 6 },
    { key: 'rentResidentialOrOther', title: 'Rent Received', type: 'amount', order: 7 },
    { key: 'rentCommercial', title: 'Rent Received', type: 'amount', order: 8 },
    { key: 'advanceResidentialOrOther', title: 'Any Charge Paid by Tenant', type: 'amount', order: 9 },
    { key: 'advanceCommercial', title: 'Any Charge Paid by Tenant', type: 'amount', order: 10 },
    { key: 'vacancyAllowanceResidentialOther', title: 'Less: Vacancy Allowance', type: 'amount', order: 11 },
    { key: 'vacancyAllowanceCommercial', title: 'Less: Vacancy Allowance', type: 'amount', order: 12 },
    { key: 'totalRentResidential', title: 'Total Rent', type: 'amount', order: 13 },
    { key: 'totalRentCommercial', title: 'Total Rent', type: 'amount', order: 14 },
    { key: 'netTotalRentResidential', title: 'Net Total Rent', type: 'amount', order: 15 },
    { key: 'insurancePremium', title: 'Insurance Premium', type: 'amount', order: 16 },
    { key: 'interestOnLoanMortgageCapital', title: 'Interest paid on Loan/Mortgage/Capital Charge', type: 'amount', order: 17 },
    { key: 'municipalLocalTaxOrLandRevenue', title: 'Municipal, Local Tax or Land Revenue', type: 'amount', order: 18 },
    { key: 'repairCollection', title: 'Repair, Collections, etc.', type: 'amount', order: 19 },
    { key: 'preRentalInterestOnLoanMortgageCapital', title: 'Pre-rental interest paid on Loan/Mortgage/Capital', type: 'amount', order: 20 },
    { key: 'other', title: 'Other (if any)', type: 'amount', order: 21 },
    { key: 'totalDeduction', title: 'Total', type: 'amount', order: 22 },
    { key: 'allowableDeduction', title: 'Allowable deduction', type: 'amount', order: 23 },
    { key: 'unadjustableAdvanceAmt', title: 'Unadjustable and non-refundable Advance, Selami, Premium etc.', type: 'amount', order: 25, group: 'specialRentalIncome' },
    { key: 'adjustableAdvanceAmt', title: 'Adjustable deposit, security deposit, advance, etc.', type: 'amount', order: 26, group: 'specialRentalIncome' },
    { key: 'unspentRepairCollection', title: 'Unspent Repair, Collections, etc.', type: 'amount', order: 27, group: 'specialRentalIncome' },
    { key: 'finalTotal', title: '(Net Total Rent - Deductions)', type: 'amount', order: 24 },
];

export const INCOME_FORM_OTHER_PROPERTY_RENT_KEYS: IncomeFormRentKey[] = [
    { key: 'propertyType', title: 'Property Type', type: 'text', order: 1 },
    { key: 'propertyDetails', title: 'Property Details', type: 'text', order: 2 },
    { key: 'propertyDescription', title: 'Property Description', type: 'text', order: 3 },
    { key: 'selfOccupiedArea', title: 'Total Area', type: 'text', order: 3.1 },
    { key: 'occupiedAreaResidential', title: 'Rented Area', type: 'text', order: 3.2 },
    // { key: 'totalArea', title: 'Total Area', type: 'text', order: 3.3 },
    { key: 'rentalPeriodResidentialOrOther', title: 'Rental period (Months)', type: 'text', order: 3.4 },
    { key: 'serviceChargePaid', title: 'Service Charge paid by tenant', type: 'text', order: 3.5 },
    { key: 'ownershipRadio', title: 'Are you the only owner', type: 'text', order: 3.6 },
    { key: 'shareOfOwnership', title: 'Share of Your Ownership (%)', type: 'text', order: 4 },
    { key: 'otherOwnersName', title: 'Name, TIN/NID of Other Owner(s)', type: 'text', order: 5 },
    { key: 'annualResidentialOrOther', title: 'Annual Rent', type: 'amount', order: 6 },
    { key: 'rentResidentialOrOther', title: 'Rent received', type: 'amount', order: 7 },
    { key: 'anyOtherResidentialOrOther', title: 'Any Charge Paid by Tenant', type: 'amount', order: 8 },
    { key: 'vacancyAllowanceResidentialOther', title: 'Less: Vacancy Allowance', type: 'amount', order: 9 },
    { key: 'netTotalRentResidential', title: 'Total', type: 'amount', order: 10 },
    { key: 'insurancePremium', title: 'Insurance Premium', type: 'amount', order: 11 },
    { key: 'interestOnLoanMortgageCapital', title: 'Interest paid on Loan/Mortgage/Capital Charge', type: 'amount', order: 12 },
    { key: 'municipalLocalTaxOrLandRevenue', title: 'Municipal, Local Tax or Land Revenue', type: 'amount', order: 13 },
    { key: 'repairCollection', title: 'Repair, Collections, etc.', type: 'amount', order: 14 },
    { key: 'other', title: 'Other (if any)', type: 'amount', order: 15 },
    { key: 'totalDeduction', title: 'Total', type: 'amount', order: 16 },
    { key: 'allowableDeduction', title: 'Allowable deduction', type: 'amount', order: 17 },
    { key: 'unadjustableAdvanceAmt', title: 'Unadjustable and non-refundable Advance, Selami, Premium etc.', type: 'amount', order: 19, group: 'specialRentalIncome' },
    { key: 'adjustableAdvanceAmt', title: 'Adjustable deposit, security deposit, advance, etc.', type: 'amount', order: 20, group: 'specialRentalIncome' },
    { key: 'unspentRepairCollection', title: 'Amount of Expense for which tax has not been deducted', type: 'amount', order: 21, group: 'specialRentalIncome' },
    { key: 'finalTotal', title: '(Total Rent - Deductions)', type: 'amount', order: 18 },
];

export const PROPERTY_TYPE_LABELS: Record<string, string> = {
    House_Property: 'House Property',
    Others_Rent: 'Other Property',
};

export const PROPERTY_DETAILS_LABELS: Record<string, string> = {
    Land: 'Land',
    Factory: 'Factory, Building with Plant & Machineries',
    Business_Premises: 'Business Premises',
    Furniture: 'Furniture fixtures and fittings',
    Machineries: 'Machineries',
    Personal_vehical: 'Personal vehicle',
    Other_capital_assets: 'Any other capital assets',
};
